export const technos = [
    {
        "name": "React",
        "type": "Framework"
    },
    {
        "name": "NodeJS",
        "type": "Framework"
    },
    {
        "name": "Angluar",
        "type": "Framework"
    },
    {
        "HTML": "HTML",
        "type": "Language",
    },
    {
        "name": "CSS",
        "type": "Language",
    },
    {
        "name": "SCSS/SASS",
        "type": "Language",
    },
    {
        "name": "Javascript",
        "type": "Language",
    },
    {
        "name": "Typescript",
        "type": "Language",
    },
    {
        "name": "Python",
        "type": "Language",
    },
    {
        "name": "Flask",
        "type": "Framework",
    },
    {
        "name": "C++",
        "type": "Language",
    },
    {
        "name": "C",
        "type": "Language",
    },
    {
        "name": "Java",
        "type": "Language",
    },
    {
        "name": "J2EE",
        "type": "Framework",
    },
    {
        "name": "PHP",
        "type": "Language",
    },
    {
        "name": "SQL",
        "type": "Language",
    },
    {
        "name": "MongoDB",
        "type": "Database",
    },
    {
        "name": "MySQL",
        "type": "Database",
    },
    {
        "name": "Godot Engine",
        "type": "Game Engine",
    }
]